import { useContext, useEffect } from "react";
import { USelectContext } from "../context/context";
export const useAutoFocusInput = (inputRef) => {
    const { showDropdown } = useContext(USelectContext);
    useEffect(() => {
        if (showDropdown) {
            setTimeout(() => inputRef?.current?.focus(), 0);
        }
    }, [showDropdown, inputRef]);
};
